module.exports = __webpack_public_path__ + "static/media/terrain-grass-03.d096f61f.svg";